module.exports = __webpack_public_path__ + "img/mp-qr.edca00ea.jpg";